const removeTrailingZeros = input => {
	if (!/^-?\d*\.?\d*$/.test(String(input)) || !input) {
		return input;
	}

	return String(input).replace(/^(\d+\.\d*?[1-9])0+$/, '$1');
};

export default removeTrailingZeros;
